import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ICountryInfo } from '../../../common/core/primitives/phone-numbers/models/phone-number-flag.model';
import { utilityManagementUrl } from '../../../constants';

@Injectable({
  providedIn: 'root'
})
export class PublicService {
  selectedCountry = new BehaviorSubject<ICountryInfo | null | any>({});
  fullPageLoading = new BehaviorSubject<boolean>(false);

  isAddNewBtnChanges = new BehaviorSubject<any>({});

  constructor(
    private datePipe: DatePipe,
    private _HttpClient: HttpClient
  ) { }

  // Method to format date without timezone, optionally adding days and formatting
  formatDateWithoutTimezone(date: string | Date, addDay?: number, format?: string): string | Date | any {
    let dateObj = typeof date === 'string' ? new Date(date) : new Date(date);
    dateObj.setHours(0, 0, 0, 0);
    // If addDay is provided, add the specified number of days
    if (addDay) {
      dateObj.setDate(dateObj.getDate() + addDay);
    }
    // If format is provided, return the formatted date string
    if (format) {
      return this.datePipe.transform(dateObj, format) ?? dateObj;
    }
    return dateObj;
  }

  // Utility function to extract an array of specific property values from an array of objects
  extractPropertyValues(items: any[], property: any): any {
    return items?.map((item) => item[property]);
  }

  // Exposing the selectedCountry as an observable
  getSelectedCountry() {
    return this.selectedCountry.asObservable();
  }

  // Return the latest value of selectedCountryDialog (from the BehaviorSubject)
  getSelectedCountryValue(): ICountryInfo | null | any {
    return this.selectedCountry.value;
  }

  getImageURLById(Id: string | undefined): Observable<any> {
    return this._HttpClient.get<any>(`${utilityManagementUrl}/attachments/${Id}/as-download-url`);
  }

  getCurrentLang(): string {
    return localStorage.getItem('lang') || 'en';
  }
}

/**
 * Removes keys with falsy values (null, undefined, or empty strings) from an object.
 *
 * @param obj The object to clean.
 * @returns A new object with only truthy values.
 */
export function removeFalsyKeys<T extends Record<string, any>>(obj: T): Partial<T> {
  const cleanedObject: Partial<T> = { ...obj }; // Create a shallow copy
  Object.keys(cleanedObject).forEach((key) => {
    if (cleanedObject[key] === null || cleanedObject[key] === undefined || cleanedObject[key] === '') {
      delete cleanedObject[key];
    }
  });
  return cleanedObject;
}
